export { CHANNEL_EVENT_MODEL_FINGERPRINT } from '../__generated__/com/hubspot/copilot/models/chat/ChannelEvent';
export const ABLY_ID = 'academy-ai-assistant';
export const LESSONS_PATH_FRAGMENT = '/lessons';
export const TRACKS_PATH_FRAGMENT = '/tracks';
export const SHORT_CONTENT_PATH_FRAGMENT = '/shortvideo';